module.exports = "pegasus/assets/hexagon-youtube.png";